// Central site configuration — owner-editable.
// External links below were supplied and verified by the project owner.

export const SITE = {
  name: "Congo Bourse",
  initiative: "MouyIA",
  contactEmail: "cmouya@congobourse.org",
  canonicalBase: "https://www.congobourse.org",
};

export const LEARNOVA = {
  prototypeUrl: "https://learnova-drc.netlify.app/",
  youtubeVideoId: "KMkx9Qy3xD4",
  youtubeUrl: "https://youtu.be/KMkx9Qy3xD4",
  demoLanguage: "en",
};

// Real screenshots of the functioning prototype, supplied by the project owner.
// Original uploaded files, served unmodified. Gallery renders only when this list is non-empty.
// Order = learner journey: goal → roadmap → lesson → dashboard → home.
export const LEARNOVA_EVIDENCE = [
  "/evidence/learnova-goal.png",
  "/evidence/learnova-roadmap.png",
  "/evidence/learnova-lesson.png",
  "/evidence/learnova-dashboard.png",
  "/evidence/learnova-home.png",
];

// Applications portfolio — add approved applications here.
// status: "prototype" | "development" | "concept"
// published: false keeps the entry out of the public interface.
export const APPLICATIONS = [
  {
    slug: "learnova",
    name: "Learnova",
    status: "prototype",
    featured: true,
    published: true,
    path: "/applications/learnova",
    externalUrl: LEARNOVA.prototypeUrl,
  },
];
